import LinkingAccountForm from './LinkingAccountForm';
export default LinkingAccountForm;
export * from './LinkingAccountForm';
